export enum Edge {
    NOT_EDGED,
    PROFILED,
    EDGED,
}
